/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataAdditionalServicePageItemRespVo } from './PageDataAdditionalServicePageItemRespVo';
import {
    PageDataAdditionalServicePageItemRespVoFromJSON,
    PageDataAdditionalServicePageItemRespVoFromJSONTyped,
    PageDataAdditionalServicePageItemRespVoToJSON,
    PageDataAdditionalServicePageItemRespVoToJSONTyped,
} from './PageDataAdditionalServicePageItemRespVo';

/**
 * 
 * @export
 * @interface ResponsePageDataAdditionalServicePageItemRespVo
 */
export interface ResponsePageDataAdditionalServicePageItemRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataAdditionalServicePageItemRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataAdditionalServicePageItemRespVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataAdditionalServicePageItemRespVo}
     * @memberof ResponsePageDataAdditionalServicePageItemRespVo
     */
    data?: PageDataAdditionalServicePageItemRespVo;
}

/**
 * Check if a given object implements the ResponsePageDataAdditionalServicePageItemRespVo interface.
 */
export function instanceOfResponsePageDataAdditionalServicePageItemRespVo(value: object): value is ResponsePageDataAdditionalServicePageItemRespVo {
    return true;
}

export function ResponsePageDataAdditionalServicePageItemRespVoFromJSON(json: any): ResponsePageDataAdditionalServicePageItemRespVo {
    return ResponsePageDataAdditionalServicePageItemRespVoFromJSONTyped(json, false);
}

export function ResponsePageDataAdditionalServicePageItemRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataAdditionalServicePageItemRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataAdditionalServicePageItemRespVoFromJSON(json['data']),
    };
}

export function ResponsePageDataAdditionalServicePageItemRespVoToJSON(json: any): ResponsePageDataAdditionalServicePageItemRespVo {
    return ResponsePageDataAdditionalServicePageItemRespVoToJSONTyped(json, false);
}

export function ResponsePageDataAdditionalServicePageItemRespVoToJSONTyped(value?: ResponsePageDataAdditionalServicePageItemRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataAdditionalServicePageItemRespVoToJSON(value['data']),
    };
}

